import { FrmAccount } from "components/formFields/frm/FrmAccount";
import { FrmPaymentMethod } from "components/formFields/frm/FrmPaymentMethod";

import { i18n } from "services/i18nService";

export function PayPalPaymentFields(props) {
  const { record, handleInputFieldChange } = props;

  return (
    <>
      <FrmAccount
        name="incomeAccount"
        label={i18n("frmLabel.PayPalIncomeAccount")}
        onValueChange={handleInputFieldChange}
        value={record.incomeAccount}
        accountType="income"
        helpText={i18n("cart.incomeAccount.hoverHelp")}
      />
      <FrmAccount
        name="feeAccount"
        label={i18n("frmLabel.PayPalFeeAccount")}
        onValueChange={handleInputFieldChange}
        value={record.feeAccount}
        helpText={i18n("cart.feeAccount.hoverHelp")}
      />
      <FrmPaymentMethod
        name="paymentMethod"
        label={i18n("frmLabel.PaymentMethod")}
        value={record.paymentMethod}
        onValueChange={handleInputFieldChange}
      />
    </>
  );
}
